import UI_ACTIONS from '../../constants/actions/ui'
const defaultState = {
	openMenu: false,
}
const UIReducer = (state = defaultState, {type, payload}) => {
	switch(type){
		case UI_ACTIONS.TOGGLE_DRAWER:
			return {
				...state,
				openMenu: !state.openMenu
			}
		default:
			return {
				...state
			}
	}
}
export default UIReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/ui.js